/**
 * SCAN TO PAY (Phase 5 depth, FR-U-TXN). Point at a QR to pay a person or a merchant till. Preview:
 * live camera decoding arrives with the payments rail; today the manual entry is the working path, and
 * it routes into the real Send flow so nothing about the payment itself is faked.
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export default function Scan() {
  const navigate = useNavigate();
  const [manual, setManual] = useState(false);
  const [target, setTarget] = useState('');

  return (
    <div className="mx-auto max-w-md space-y-5">
      <Link
        to="/home"
        className="inline-flex items-center gap-1 text-sm text-ink-muted hover:text-ink"
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 6l-6 6 6 6" />
        </svg>
        Home
      </Link>

      <header>
        <h1 className="text-page-title text-ink">Scan to pay</h1>
        <p className="mt-0.5 text-sm text-ink-muted">Point at a QR to pay a person or a till.</p>
      </header>

      {/* Viewfinder. A framed dark surface with a scanning window; the live camera arrives with the rail. */}
      <div className="relative mx-auto aspect-square w-full overflow-hidden rounded-xl bg-ink/90">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative h-48 w-48">
            {[
              'left-0 top-0 border-l-2 border-t-2',
              'right-0 top-0 border-r-2 border-t-2',
              'left-0 bottom-0 border-l-2 border-b-2',
              'right-0 bottom-0 border-r-2 border-b-2',
            ].map((c) => (
              <span key={c} className={`absolute h-8 w-8 rounded-sm border-white/80 ${c}`} />
            ))}
          </div>
        </div>
        <p className="absolute inset-x-0 bottom-4 text-center text-xs text-white/70">
          Camera preview activates with the payments rail
        </p>
      </div>

      {!manual ? (
        <button
          onClick={() => setManual(true)}
          className="w-full rounded-field border border-border bg-surface py-3 text-sm font-medium text-ink transition hover:bg-surface-sunken"
        >
          Enter ID or till manually
        </button>
      ) : (
        <div className="space-y-3 rounded-xl border border-border bg-surface p-6 shadow-card">
          <label htmlFor="t" className="block text-sm font-medium text-ink">
            Recipient ID or till number
          </label>
          <input
            id="t"
            autoFocus
            value={target}
            onChange={(e) => setTarget(e.target.value)}
            placeholder="VASP ID or LIPA-xxxx"
            className="w-full rounded-field border border-border bg-surface px-3 py-2.5 font-mono text-base text-ink outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/25"
          />
          <button
            onClick={() => navigate(`/transact?to=${encodeURIComponent(target)}`)}
            disabled={!target}
            className="w-full rounded-field bg-primary py-3 text-sm font-semibold text-white shadow-soft transition hover:bg-primary-light disabled:opacity-50"
          >
            Continue to pay
          </button>
        </div>
      )}

      <p className="text-center text-xs text-ink-subtle">
        Manual entry routes into the normal Send flow, so the payment runs the same compliance
        checks.
      </p>
    </div>
  );
}
